import React from 'react';
import down from "../../../assets/images/footer-draw/down.gif"
import dialogQuestion from "../../../assets/images/footer-draw/dialog_question.png"
import up from "../../../assets/images/footer-draw/up.gif"
import nope from "../../../assets/images/footer-draw/nope.gif"
import warring from "../../../assets/images/footer-draw/warring.gif"

const DrawingBottom = () => {
    return (
        <div className="box_thongkexosoext">
            <h2 className="title_kqtkext">
                Thống kê xổ số Miền Nam đến ngày 04/06/2026{" "}
            </h2>
            <form action="#" method="post">
                <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                    <tbody>
                    <tr>
                        <td align="left" valign="middle" nowrap="nowrap">
                            <label>
                                <input
                                    type="radio"
                                    name="RadioGroup1"
                                    defaultValue={3}
                                    id="RadioGroup1_2"
                                    onClick={() => console.log("1")}
                                    defaultChecked="checked"
                                />
                                Cả 3 đài
                            </label>
                        </td>
                        <td align="left" valign="middle" nowrap="nowrap">
                            <label>
                                <input
                                    type="radio"
                                    name="RadioGroup1"
                                    defaultValue={2}
                                    id="RadioGroup1_1"
                                    onClick={() => console.log("2")}
                                />
                                Đài (1 &amp; 2)
                            </label>
                        </td>
                        <td align="left" valign="middle" nowrap="nowrap">
                            <label>
                                <input
                                    type="radio"
                                    name="RadioGroup1"
                                    defaultValue={1}
                                    id="RadioGroup1_0"
                                    onClick={() => console.log("3")}
                                />
                                Chỉ đài (1)
                            </label>
                        </td>
                        <td align="right" valign="middle" nowrap="nowrap">
                            <a href="/" target="_blank">
                                Nâng cao
                            </a>
                            <a href="/" target="_blank">
                                <img
                                    src={dialogQuestion} alt="dialogQuestion"
                                    hspace={5}
                                    border={0}
                                    align="absmiddle"
                                />
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </form>
            <img src={warring} alt="warring"/> Lưu ý:{" "}
            <em>Thống kê cập nhật sau khi kết thúc xổ số.</em>
            <div id="bangthongkexoso">
                <div className="clear"/>
                <div className="box_tkdefault_xhn3l">
                    <h4 className="box_tkdefault_title">
                        <a
                            href="/"
                            target="_blank"
                        >
                            Các cặp số xuất hiện nhiều nhất trong 3 ngày:
                        </a>
                    </h4>
                    <table
                        width="100%"
                        border={0}
                        cellSpacing={0}
                        cellPadding={2}
                        id="caccapsoxuathien"
                    >
                        <tbody>
                        <tr>
                            <td width={40}>
                                <a
                                    title="Xem thống kê lô KQXS Miền Nam Cặp số 31 từ ngày: 20/11/2021 Đến: 20/12/2021"
                                    href="/"
                                    target="_blank"
                                >
                                    <span className="bol30 bol30_3">31</span>
                                </a>
                            </td>
                            <td width={50} valign="middle">
                                ( 5 Lần )
                            </td>
                            <td width={100} valign="middle">
                                <img src={up} alt="up" align="absmiddle" hspace={5}/>
                                Tăng 2{" "}
                            </td>
                            <td valign="middle">
                                <div className="chiso" style={{width: 250}}/>
                            </td>
                        </tr>
                        <tr>
                            <td width={40}>
                                <a
                                    title="Xem thống kê lô KQXS Miền Nam Cặp số 39 từ ngày: 20/11/2021 Đến: 20/12/2021"
                                    href="/"
                                    target="_blank"
                                >
                                    <span className="bol30 bol30_3">39</span>
                                </a>
                            </td>
                            <td width={50} valign="middle">
                                ( 5 Lần )
                            </td>
                            <td width={100} valign="middle">
                                <img src={up} alt="up" align="absmiddle" hspace={5}/>
                                Tăng 2{" "}
                            </td>
                            <td valign="middle">
                                <div className="chiso" style={{width: 250}}/>
                            </td>
                        </tr>
                        <tr>
                            <td width={40}>
                                <a
                                    title="Xem thống kê lô KQXS Miền Nam Cặp số 98 từ ngày: 20/11/2021 Đến: 20/12/2021"
                                    href="/"
                                    target="_blank"
                                >
                                    <span className="bol30 bol30_9">98</span>
                                </a>
                            </td>
                            <td width={50} valign="middle">
                                ( 5 Lần )
                            </td>
                            <td width={100} valign="middle">
                                <img src={up} alt="up" align="absmiddle" hspace={5}/>
                                Tăng 1{" "}
                            </td>
                            <td valign="middle">
                                <div className="chiso" style={{width: 250}}/>
                            </td>
                        </tr>
                        <tr>
                            <td width={40}>
                                <a
                                    title="Xem thống kê lô KQXS Miền Nam Cặp số 12 từ ngày: 20/11/2021 Đến: 20/12/2021"
                                    href="/"
                                    target="_blank"
                                >
                                    <span className="bol30 bol30_1">12</span>
                                </a>
                            </td>
                            <td width={50} valign="middle">
                                ( 4 Lần )
                            </td>
                            <td width={100} valign="middle">
                                <img src={down} alt="down" align="absmiddle" hspace={5}/>
                                Giảm 1{" "}
                            </td>
                            <td valign="middle">
                                <div className="chiso" style={{width: 200}}/>
                            </td>
                        </tr>
                        <tr>
                            <td width={40}>
                                <a
                                    title="Xem thống kê lô KQXS Miền Nam Cặp số 21 từ ngày: 20/11/2021 Đến: 20/12/2021"
                                    href="/"
                                    target="_blank"
                                >
                                    <span className="bol30 bol30_2">21</span>
                                </a>
                            </td>
                            <td width={50} valign="middle">
                                ( 4 Lần )
                            </td>
                            <td width={100} valign="middle">
                                <img src={up} alt="up" align="absmiddle" hspace={5}/>
                                Tăng 1{" "}
                            </td>
                            <td valign="middle">
                                <div className="chiso" style={{width: 200}}/>
                            </td>
                        </tr>
                        <tr>
                            <td width={40}>
                                <a
                                    title="Xem thống kê lô KQXS Miền Nam Cặp số 33 từ ngày: 20/11/2021 Đến: 20/12/2021"
                                    href="/"
                                    target="_blank"
                                >
                                    <span className="bol30 bol30_3">33</span>
                                </a>
                            </td>
                            <td width={55} valign="middle">
                                ( 4 Lần )
                            </td>
                            <td width={100} valign="middle">
                                <img src={nope} alt="nope" align="absmiddle" hspace={5}/> Không
                                tăng
                            </td>
                            <td valign="middle">
                                <div className="chiso" style={{width: 200}}/>
                            </td>
                        </tr>
                        <tr>
                            <td width={40}>
                                <a
                                    title="Xem thống kê lô KQXS Miền Nam Cặp số 61 từ ngày: 20/11/2021 Đến: 20/12/2021"
                                    href="/"
                                    target="_blank"
                                >
                                    <span className="bol30 bol30_6">61</span>
                                </a>
                            </td>
                            <td width={55} valign="middle">
                                ( 4 Lần )
                            </td>
                            <td width={100} valign="middle">
                                <img src={nope} alt="nope" align="absmiddle" hspace={5}/> Không
                                tăng
                            </td>
                            <td valign="middle">
                                <div className="chiso" style={{width: 200}}/>
                            </td>
                        </tr>
                        <tr>
                            <td width={40}>
                                <a
                                    title="Xem thống kê lô KQXS Miền Nam Cặp số 64 từ ngày: 20/11/2021 Đến: 20/12/2021"
                                    href="/"
                                    target="_blank"
                                >
                                    <span className="bol30 bol30_6">64</span>
                                </a>
                            </td>
                            <td width={55} valign="middle">
                                ( 4 Lần )
                            </td>
                            <td width={100} valign="middle">
                                <img src={up} alt="up" align="absmiddle" hspace={5}/>
                                Tăng 2{" "}
                            </td>
                            <td valign="middle">
                                <div className="chiso" style={{width: 200}}/>
                            </td>
                        </tr>
                        <tr>
                            <td width={40}>
                                <a
                                    title="Xem thống kê lô KQXS Miền Nam Cặp số 86 từ ngày: 20/11/2021 Đến: 20/12/2021"
                                    href="/"
                                    target="_blank"
                                >
                                    <span className="bol30 bol30_8">86</span>
                                </a>
                            </td>
                            <td width={55} valign="middle">
                                ( 4 Lần )
                            </td>
                            <td width={100} valign="middle">
                                <img src={up} alt="up" align="absmiddle" hspace={5}/>
                                Tăng 2{" "}
                            </td>
                            <td valign="middle">
                                <div className="chiso" style={{width: 200}}/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="clear"/>
                <div className="box_tkdefault_xhn3l">
                    <h4 className="box_tkdefault_title">
                        <a
                            href="/"
                            target="_blank"
                        >
                            Các cặp số xuất hiện nhiều nhất trong 7 ngày:
                        </a>
                    </h4>
                    <table
                        width="100%"
                        border={0}
                        cellSpacing={0}
                        cellPadding={2}
                        id="caccapsoxuathien30"
                    >
                        <tbody>
                        <tr>
                            <td width={30}>
                                <a
                                    title="Xem thống kê lô KQXS Miền Nam Cặp số 20 từ ngày: 20/11/2021 Đến: 20/12/2021"
                                    href="/"
                                    target="_blank"
                                >
                                    <span className="bol30 bol30_2">20</span>
                                </a>
                            </td>
                            <td width={55}> ( 8 Lần )</td>
                            <td width={100}>
                                <img src={nope} alt="nope" align="absmiddle" hspace={5}/> Không
                                tăng
                            </td>
                            <td>
                                <div className="chiso" style={{width: 250}}/>
                            </td>
                        </tr>
                        <tr>
                            <td width={30}>
                                <a
                                    title="Xem thống kê lô KQXS Miền Nam Cặp số 31 từ ngày: 20/11/2021 Đến: 20/12/2021"
                                    href="/"
                                    target="_blank"
                                >
                                    <span className="bol30 bol30_3">31</span>
                                </a>
                            </td>
                            <td width={55}> ( 8 Lần )</td>
                            <td width={100}>
                                <img src={up} alt="up" align="absmiddle" hspace={5}/>
                                Tăng 2{" "}
                            </td>
                            <td>
                                <div className="chiso" style={{width: 250}}/>
                            </td>
                        </tr>
                        <tr>
                            <td width={30}>
                                <a
                                    title="Xem thống kê lô KQXS Miền Nam Cặp số 39 từ ngày: 20/11/2021 Đến: 20/12/2021"
                                    href="/"
                                    target="_blank"
                                >
                                    <span className="bol30 bol30_3">39</span>
                                </a>
                            </td>
                            <td width={55}> ( 8 Lần )</td>
                            <td width={100}>
                                <img src={up} alt="up" align="absmiddle" hspace={5}/>
                                Tăng 2{" "}
                            </td>
                            <td>
                                <div className="chiso" style={{width: 250}}/>
                            </td>
                        </tr>
                        <tr>
                            <td width={30}>
                                <a
                                    title="Xem thống kê lô KQXS Miền Nam Cặp số 42 từ ngày: 20/11/2021 Đến: 20/12/2021"
                                    href="/"
                                    target="_blank"
                                >
                                    <span className="bol30 bol30_4">42</span>
                                </a>
                            </td>
                            <td width={55}> ( 7 Lần )</td>
                            <td width={100}>
                                <img src={up} alt="up" align="absmiddle" hspace={5}/>
                                Tăng 1{" "}
                            </td>
                            <td>
                                <div className="chiso" style={{width: 219}}/>
                            </td>
                        </tr>
                        <tr>
                            <td width={30}>
                                <a
                                    title="Xem thống kê lô KQXS Miền Nam Cặp số 54 từ ngày: 20/11/2021 Đến: 20/12/2021"
                                    href="/"
                                    target="_blank"
                                >
                                    <span className="bol30 bol30_5">54</span>
                                </a>
                            </td>
                            <td width={55}> ( 7 Lần )</td>
                            <td width={100}>
                                <img src={up} alt="up" align="absmiddle" hspace={5}/>
                                Tăng 2{" "}
                            </td>
                            <td>
                                <div className="chiso" style={{width: 219}}/>
                            </td>
                        </tr>
                        <tr>
                            <td width={40}>
                                <a
                                    title="Xem thống kê lô KQXS Miền Nam Cặp số 98 từ ngày: 20/11/2021 Đến: 20/12/2021"
                                    href="/"
                                    target="_blank"
                                >
                                    <span className="bol30 bol30_9">98</span>
                                </a>
                            </td>
                            <td width={50} valign="middle">
                                ( 7 Lần )
                            </td>
                            <td width={100} valign="middle">
                                <img src={nope} alt="nope" align="absmiddle" hspace={5}/> Không
                                tăng
                            </td>
                            <td valign="middle">
                                <div className="chiso" style={{width: 219}}/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="clear"/>
                <div className="box_tkdefault_xhn3l">
                    <h4 className="box_tkdefault_title">Các cặp số ra liên tiếp:</h4>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 00 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_0">00</span>
                        </a>{" "}
                        ( 3 Ngày ) ( 3 lần )
                    </div>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 21 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_2">21</span>
                        </a>{" "}
                        ( 3 Ngày ) ( 4 lần )
                    </div>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 27 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_2">27</span>
                        </a>{" "}
                        ( 3 Ngày ) ( 3 lần )
                    </div>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 31 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_3">31</span>
                        </a>{" "}
                        ( 3 Ngày ) ( 5 lần )
                    </div>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 64 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_6">64</span>
                        </a>{" "}
                        ( 3 Ngày ) ( 4 lần )
                    </div>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 68 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_6">68</span>
                        </a>{" "}
                        ( 3 Ngày ) ( 3 lần )
                    </div>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 86 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_8">86</span>
                        </a>{" "}
                        ( 3 Ngày ) ( 4 lần )
                    </div>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 98 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_9">98</span>
                        </a>{" "}
                        ( 3 Ngày ) ( 5 lần )
                    </div>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 04 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_4">04</span>
                        </a>{" "}
                        ( 2 Ngày ) ( 2 lần )
                    </div>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 26 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_2">26</span>
                        </a>{" "}
                        ( 2 Ngày ) ( 2 lần )
                    </div>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 28 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_2">28</span>
                        </a>{" "}
                        ( 2 Ngày ) ( 2 lần )
                    </div>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 39 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_3">39</span>
                        </a>{" "}
                        ( 2 Ngày ) ( 5 lần )
                    </div>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 40 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_4">40</span>
                        </a>{" "}
                        ( 2 Ngày ) ( 2 lần )
                    </div>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 49 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_4">49</span>
                        </a>{" "}
                        ( 2 Ngày ) ( 3 lần )
                    </div>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 54 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_5">54</span>
                        </a>{" "}
                        ( 2 Ngày ) ( 3 lần )
                    </div>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 56 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_5">56</span>
                        </a>{" "}
                        ( 2 Ngày ) ( 2 lần )
                    </div>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 73 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_7">73</span>
                        </a>{" "}
                        ( 2 Ngày ) ( 2 lần )
                    </div>
                    <div style={{float: "left", margin: 2, width: "30%"}}>
                        <a
                            title="Xem thống kê lô KQXS Miền Nam Cặp số 84 từ ngày: 20/11/2021 Đến: 20/12/2021"
                            href="/"
                            target="_blank"
                        >
                            <span className="bol30 bol30_8">84</span>
                        </a>{" "}
                        ( 2 Ngày ) ( 2 lần )
                    </div>
                </div>
                <div className="clear"/>
                <div className="box_tkdefault_xhn3l">
                    <h4 className="box_tkdefault_title">
                        Những cặp số không xuất hiện lâu nhất:
                    </h4>
                    <table width="100%" border={0} cellSpacing={0} cellPadding={5}>
                        <tbody>
                        <tr>
                            <td>
                                <div style={{float: "left", margin: 2, width: "30%"}}>
                                    <a
                                        href="/"
                                        title=" Xem Gan Cực Đại cặp số 94 Xổ số Miền Nam"
                                        target="_blank"
                                    >
                                        <span className="bol30 bol30_9">94</span>
                                    </a>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;( 8 ngày )
                                </div>
                                <div style={{float: "left", margin: 2, width: "30%"}}>
                                    <a
                                        href="/"
                                        title=" Xem Gan Cực Đại cặp số 75 Xổ số Miền Nam"
                                        target="_blank"
                                    >
                                        <span className="bol30 bol30_7">75</span>
                                    </a>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;( 7 ngày )
                                </div>
                                <div style={{float: "left", margin: 2, width: "30%"}}>
                                    <a
                                        href="/"
                                        title=" Xem Gan Cực Đại cặp số 18 Xổ số Miền Nam"
                                        target="_blank"
                                    >
                                        <span className="bol30 bol30_1">18</span>
                                    </a>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;( 5 ngày )
                                </div>
                                <div style={{float: "left", margin: 2, width: "30%"}}>
                                    <a
                                        href="/"
                                        title=" Xem Gan Cực Đại cặp số 88 Xổ số Miền Nam"
                                        target="_blank"
                                    >
                                        <span className="bol30 bol30_8">88</span>
                                    </a>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;( 5 ngày )
                                </div>
                                <div style={{float: "left", margin: 2, width: "30%"}}>
                                    <a
                                        href="/"
                                        title=" Xem Gan Cực Đại cặp số 41 Xổ số Miền Nam"
                                        target="_blank"
                                    >
                                        <span className="bol30 bol30_4">41</span>
                                    </a>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;( 4 ngày )
                                </div>
                                <div style={{float: "left", margin: 2, width: "30%"}}>
                                    <a
                                        href="/"
                                        title=" Xem Gan Cực Đại cặp số 51 Xổ số Miền Nam"
                                        target="_blank"
                                    >
                                        <span className="bol30 bol30_5">51</span>
                                    </a>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;( 4 ngày )
                                </div>
                                <div style={{float: "left", margin: 2, width: "30%"}}>
                                    <a
                                        href="/"
                                        title=" Xem Gan Cực Đại cặp số 83 Xổ số Miền Nam"
                                        target="_blank"
                                    >
                                        <span className="bol30 bol30_8">83</span>
                                    </a>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;( 4 ngày )
                                </div>
                                <div style={{float: "left", margin: 2, width: "30%"}}>
                                    <a
                                        href="/"
                                        title=" Xem Gan Cực Đại cặp số 85 Xổ số Miền Nam"
                                        target="_blank"
                                    >
                                        <span className="bol30 bol30_8">85</span>
                                    </a>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;( 4 ngày )
                                </div>
                                <div style={{float: "left", margin: 2, width: "30%"}}>
                                    <a
                                        href="/"
                                        title=" Xem Gan Cực Đại cặp số 92 Xổ số Miền Nam"
                                        target="_blank"
                                    >
                                        <span className="bol30 bol30_9">92</span>
                                    </a>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;( 4 ngày )
                                </div>
                                <div style={{float: "left", margin: 2, width: "30%"}}>
                                    <a
                                        href="/"
                                        title=" Xem Gan Cực Đại cặp số 99 Xổ số Miền Nam"
                                        target="_blank"
                                    >
                                        <span className="bol30 bol30_9">99</span>
                                    </a>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;( 4 ngày )
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div id="box_tkmd_lotodauduoi" style={{position: "relative"}}>
                    <div className="clear"/>
                    <div className="box_tkdefault_xhn3l ">
                        <div className="clear"/>
                        <div style={{margin: "0 -8px -3px"}} className="boxlotodefault box_tkdefault_loto">
                            <h4 className="box_tkdefault_title">
                                Bảng Thống kê "Chục - Đơn vị" đài 1-2-3 trong{" "}
                                <input
                                    name="tkdefault_loto_songay"
                                    id="tkdefault_loto_songay"
                                    type="text"
                                    style={{
                                        width: 30,
                                        lineHeight: "100%",
                                        padding: 0,
                                        textAlign: "center",
                                        fontSize: 14
                                    }}
                                    maxLength={4}
                                    defaultValue={3}
                                />{" "}
                                ngày{" "}
                                <input
                                    name=""
                                    type="button"
                                    defaultValue="Ok"
                                    onClick="get_tkdefault_loto()"
                                />
                            </h4>
                            <table
                                width="100%"
                                border={0}
                                cellSpacing={0}
                                cellPadding={2}
                                id="thongkexxdau"
                            >
                                <tbody>
                                <tr className="header">
                                    <td width="50%" colSpan={3} align="center" nowrap="nowrap">
                                        <strong>Hàng chục</strong>
                                    </td>
                                    <td align="center" nowrap="nowrap" className="so">
                                        <strong>Số</strong>
                                    </td>
                                    <td width="50%" colSpan={3} align="center" nowrap="nowrap">
                                        <strong>Hàng đơn vị</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td nowrap="nowrap">18 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={up} alt="up" align="absmiddle" hspace={5}/>1
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "82%"}}/>
                                    </td>
                                    <td align="center" nowrap="nowrap" className="so">
                                        <span className="bol30 bol30_0">0</span>
                                    </td>
                                    <td nowrap="nowrap">16 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={down} alt="down" align="absmiddle" hspace={5}/>5
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "70%"}}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td nowrap="nowrap">12 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={down} alt="down" align="absmiddle" hspace={5}/>2
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "55%"}}/>
                                    </td>
                                    <td align="center" nowrap="nowrap" className="so">
                                        <span className="bol30 bol30_1">1</span>
                                    </td>
                                    <td nowrap="nowrap">19 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={nope} alt="nope" align="absmiddle" hspace={5}/>0
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "83%"}}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td nowrap="nowrap">20 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={down} alt="down" align="absmiddle" hspace={5}/>3
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "91%"}}/>
                                    </td>
                                    <td align="center" nowrap="nowrap" className="so">
                                        <span className="bol30 bol30_2">2</span>
                                    </td>
                                    <td nowrap="nowrap">16 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={up} alt="up" align="absmiddle" hspace={5}/>4
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "70%"}}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td nowrap="nowrap">21 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={up} alt="up" align="absmiddle" hspace={5}/>1
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "95%"}}/>
                                    </td>
                                    <td align="center" nowrap="nowrap" className="so">
                                        <span className="bol30 bol30_3">3</span>
                                    </td>
                                    <td nowrap="nowrap">13 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={down} alt="down" align="absmiddle" hspace={5}/>3
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "57%"}}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td nowrap="nowrap">15 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={down} alt="down" align="absmiddle" hspace={5}/>3
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "68%"}}/>
                                    </td>
                                    <td align="center" nowrap="nowrap" className="so">
                                        <span className="bol30 bol30_4">4</span>
                                    </td>
                                    <td nowrap="nowrap">16 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={nope} alt="nope" align="absmiddle" hspace={5}/>0
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "70%"}}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td nowrap="nowrap">19 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={up} alt="up" align="absmiddle" hspace={5}/>4
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "86%"}}/>
                                    </td>
                                    <td align="center" nowrap="nowrap" className="so">
                                        <span className="bol30 bol30_5">5</span>
                                    </td>
                                    <td nowrap="nowrap">14 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={up} alt="up" align="absmiddle" hspace={5}/>2
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "61%"}}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td nowrap="nowrap">22 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={up} alt="up" align="absmiddle" hspace={5}/>6
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "100%"}}/>
                                    </td>
                                    <td align="center" nowrap="nowrap" className="so">
                                        <span className="bol30 bol30_6">6</span>
                                    </td>
                                    <td nowrap="nowrap">17 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={nope} alt="nope" align="absmiddle" hspace={5}/>0
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "74%"}}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td nowrap="nowrap">12 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={down} alt="down" align="absmiddle" hspace={5}/>4
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "55%"}}/>
                                    </td>
                                    <td align="center" nowrap="nowrap" className="so">
                                        <span className="bol30 bol30_7">7</span>
                                    </td>
                                    <td nowrap="nowrap">12 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={down} alt="down" align="absmiddle" hspace={5}/>3
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "52%"}}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td nowrap="nowrap">11 Lần</td>
                                    <td nowrap="nowrap">
                                        <img
                                            src={nope} alt="nope"
                                            align="absmiddle"
                                            hspace={5}
                                            vspace={5}
                                        />
                                        0
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "50%"}}/>
                                    </td>
                                    <td align="center" nowrap="nowrap" className="so">
                                        <span className="bol30 bol30_8">8</span>
                                    </td>
                                    <td nowrap="nowrap">16 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={up} alt="up" align="absmiddle" hspace={5}/>1
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "70%"}}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td nowrap="nowrap">12 Lần</td>
                                    <td nowrap="nowrap">
                                        <img
                                            src={nope} alt="nope"
                                            align="absmiddle"
                                            hspace={5}
                                            vspace={5}
                                        />
                                        0
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "55%"}}/>
                                    </td>
                                    <td align="center" nowrap="nowrap" className="so">
                                        <span className="bol30 bol30_9">9</span>
                                    </td>
                                    <td nowrap="nowrap">23 Lần</td>
                                    <td nowrap="nowrap">
                                        <img src={up} alt="up" align="absmiddle" hspace={5}/>4
                                    </td>
                                    <td width={120} nowrap="nowrap">
                                        <div className="chiso" style={{width: "100%"}}/>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default DrawingBottom;
